'use client';

import Script from 'next/script';
import { GtmAnalytics } from './GtmAnalytics';
import { Suspense } from 'react';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export default function GtmProvider({ children }: { children: React.ReactNode }) {
  if (!GTM_ID) {
    console.warn('GTM ID not found. GTM will not be initialized.');
    return <>{children}</>;
  }

  return (
    <>
      {/* GTM scripts are loaded here */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
      />
      <Script id="gtm-datalayer-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        `}
      </Script>
      {children}
      {/* The component that uses the hooks is now wrapped in Suspense.
        We provide a null fallback because it renders no UI.
      */}
      <Suspense fallback={null}>
        <GtmAnalytics />
      </Suspense>
    </>
  );
}
